import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './HomepageHeader.css';

function HomepageHeader() {
    const { t } = useTranslation();

    return (
        <div className='homepage-header' style={{ backgroundImage: 'url(/images/homepage-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-7 gap-3 d-flex flex-column'>
                    <div className='chip'>
                        {t('Unlock more revenue effortlessly')}
                    </div>
                    <h1>{t('Revolutionize Your Property Management with Prostay')}</h1>
                    <p className='body-xlarge'>
                        {t('An all-in-one, customizable platform designed to streamline operations for hotels, resorts, and vacation rentals.')} <br />
                        {t('Scale effortlessly, manage smarter, and grow your business with ease.')}
                    </p>
                    {/* <div className='d-flex gap-3'>
                        <button className='light-blue-filled-btn-medium d-flex gap-2 align-items-center'>
                            {t('Watch Demo')}
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.555 9.03601L14.752 11.168C14.889 11.2593 15.0013 11.3841 15.0789 11.5292C15.1566 11.6743 15.1972 11.8364 15.1972 12.001C15.1972 12.1656 15.1566 12.3277 15.0789 12.4728C15.0013 12.618 14.889 12.7417 14.752 12.833L11.555 14.965C11.4044 15.0655 11.2293 15.1232 11.0485 15.132C10.8677 15.1408 10.6879 15.1003 10.5282 15.0149C10.3686 14.9295 10.2352 14.8023 10.1421 14.647C10.0491 14.4917 9.99998 14.3141 10 14.133V9.87001C9.99961 9.6888 10.0485 9.51088 10.1414 9.35529C10.2342 9.19969 10.3677 9.07226 10.5274 8.98661C10.687 8.90096 10.867 8.86031 11.048 8.86901C11.229 8.87771 11.4043 8.93544 11.555 9.03601Z" fill="white" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        <button className='text-btn-medium d-flex gap-2 align-items-center'>
                            {t('Read More')}
                            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L19 8M19 8L12 15M19 8H1" stroke="#22242A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div> */}
                </div>
                <div className='col-auto grid-wrapper'>
                    <div className='images-cards-grid'>
                        <div className='col d-flex left-column'>
                            <img src="/images/booking-performance.png" alt="Booking performance analytics"/>
                            <img src="/images/reports-dashboard.png" alt="Reports & analytics dashboard" />
                        </div>
                        <div className='col d-flex right-column'>
                            <img src="/images/smart-scheduling.png" alt="Booking performance analytics" />
                            <img src="/images/cloud-based-on-prem.png" alt="Reports & analytics dashboard" />
                        </div>
                    </div>
                    <img className='extra-img' src="/images/booking-performance-extra.png" alt="Booking performance analytics"/>
                </div>
            </div>
        </div>
    );
}

export default HomepageHeader;
